export default __webpack_public_path__ + "static/media/Abyssal Demon Ring of Intelligence.c2b6584b.jpg";